import { useEffect, useRef, useState } from "react";
import "./MultiPicker.css";

/**
 * 여럿을 고르는 칸. 칩을 늘어놓았을 때는 같은 줄의 다른 칸들(드롭다운·입력)과 생김새가 달라
 * 이 칸만 다른 종류의 물건으로 보였다. 닫혀 있을 때는 고른 것을 글로 말하고, 열면 세로
 * 목록에서 체크로 고른다 — 이 앱의 열 필터와 같은 모양이다.
 */
export function MultiPicker({ options, value, onChange, invalid, id, placeholder = "선택" }: {
  options: Array<{ value: string; label: string }>;
  value: string[]; onChange: (next: string[]) => void; invalid?: boolean; id?: string; placeholder?: string;
}) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const menu = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const dismiss = (event: MouseEvent) => { if (!root.current?.contains(event.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", dismiss);
    return () => document.removeEventListener("mousedown", dismiss);
  }, [open]);
  /* 고른 순서가 아니라 목록 순서로 적는다 — 월·수·금을 고르면 늘 "월 · 수 · 금"이다. */
  const chosen = options.filter(option => value.includes(option.value));
  /* 늘 아래로 편다. 위로 뒤집던 규칙은 짧은 창에서 목록이 윗줄들을 덮어, 방금 누른 칸이
     어디였는지조차 안 보이게 만들었다 — 이 앱의 다른 드롭다운과 같은 규칙이다. */
  return <div ref={root} className="multi-picker">
    <button type="button" id={id} className="multi-picker-trigger" aria-expanded={open} aria-invalid={invalid || undefined}
      onClick={() => setOpen(current => !current)}>
      <span>{chosen.length ? chosen.map(option => option.label).join(" · ") : placeholder}</span>
      <svg viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1.5 6 6.5l5-5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </button>
    {open && <div ref={menu} className="multi-picker-menu" role="group">
      {options.map(option => <label key={option.value}>
        <input type="checkbox" checked={value.includes(option.value)}
          onChange={() => onChange(value.includes(option.value) ? value.filter(item => item !== option.value) : [...value, option.value])} />
        <span>{option.label}</span>
      </label>)}
    </div>}
  </div>;
}
